export const config = {
  REGION: process.env.REACT_APP_AWS_REGION as string,
  USER_POOL_ID: process.env.REACT_APP_AWS_USER_POOL_ID as string,
  APP_CLIENT_ID: process.env.REACT_APP_AWS_APP_CLIENT_WEB_ID as string,
  IDENTITY_POOL_ID: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
};
